import { createOperation } from "../operations";

export const addCardOperation = createOperation<void>("ACCOUNT/ADD_CARD", { showSpinner: true });
export const removeCardOperation = createOperation<void>("ACCOUNT/REMOVE_CARD", { showSpinner: true });
